{% block uc_config_page %}
<sw-page class="uc-config-page">

    {% block uc_config_smart_bar_header %}
    <template #smart-bar-header>
        <h2>{{ $tc('sellops-ultimate-cart.config.title') }}</h2>
    </template>
    {% endblock %}

    {% block uc_config_smart_bar_actions %}
    <template #smart-bar-actions>
        <sw-button variant="ghost" @click="goToMilestones">
            {{ $tc('sellops-ultimate-cart.config.milestonesButton') }}
        </sw-button>
        <sw-button variant="ghost" @click="goToFreeProducts">
            {{ $tc('sellops-ultimate-cart.config.freeProductsButton') }}
        </sw-button>
        <sw-button variant="ghost" @click="goToCrossSellRules">
            {{ $tc('sellops-ultimate-cart.config.crossSellRulesButton') }}
        </sw-button>
        <sw-button variant="primary" :isLoading="isSaving" @click="onSave">
            {{ $tc('sellops-ultimate-cart.config.saveButton') }}
        </sw-button>
    </template>
    {% endblock %}

    {% block uc_config_content %}
    <template #content>
        <sw-card-view>

            <sw-card :title="$tc('sellops-ultimate-cart.theme.headline')">
                <p class="uc-config-page__subline">
                    {{ $tc('sellops-ultimate-cart.theme.subline') }}
                </p>

                {# theme/elementOrder/disabledElements live outside config.xml
                   (see index.js docblock on onSave), so they don't get
                   Shopware's built-in per-sales-channel inherit-wrapper for
                   free — this hint + lock/unlock pair reimplements the same
                   "inherited until you explicitly customize" behavior the
                   rest of this page's fields already get automatically. #}
                <p v-if="themeInherited" class="uc-config-page__inherited-hint">
                    {{ $tc('sellops-ultimate-cart.config.inheritedHint') }}
                    <sw-button size="x-small" variant="ghost" @click="customizeTheme">
                        {{ $tc('sellops-ultimate-cart.config.customizeButton') }}
                    </sw-button>
                </p>
                <p v-else-if="isSalesChannelScoped" class="uc-config-page__override-hint">
                    {{ $tc('sellops-ultimate-cart.config.overrideHint') }}
                    <sw-button size="x-small" variant="ghost" @click="resetThemeToGlobal">
                        {{ $tc('sellops-ultimate-cart.config.resetButton') }}
                    </sw-button>
                </p>

                <div :class="{ 'uc-config-page__locked': themeInherited }">
                    <sellops-uc-theme-picker
                        :value="currentTheme"
                        @update:value="onThemeChange"
                    />
                </div>
            </sw-card>

            <sw-card :title="$tc('sellops-ultimate-cart.elements.headline')">
                <p class="uc-config-page__subline">
                    {{ $tc('sellops-ultimate-cart.elements.subline') }}
                </p>

                <p v-if="elementsInherited" class="uc-config-page__inherited-hint">
                    {{ $tc('sellops-ultimate-cart.config.inheritedHint') }}
                    <sw-button size="x-small" variant="ghost" @click="customizeElements">
                        {{ $tc('sellops-ultimate-cart.config.customizeButton') }}
                    </sw-button>
                </p>
                <p v-else-if="isSalesChannelScoped" class="uc-config-page__override-hint">
                    {{ $tc('sellops-ultimate-cart.config.overrideHint') }}
                    <sw-button size="x-small" variant="ghost" @click="resetElementsToGlobal">
                        {{ $tc('sellops-ultimate-cart.config.resetButton') }}
                    </sw-button>
                </p>

                <div :class="{ 'uc-config-page__locked': elementsInherited }">
                    <sellops-uc-element-sorter
                        :value="elementOrder"
                        :disabled-keys="disabledElements"
                        @update:value="onElementOrderChange"
                        @update:disabledKeys="onDisabledElementsChange"
                    />
                </div>
            </sw-card>

            <sw-system-config
                ref="systemConfig"
                sales-channel-switchable
                domain="SellopsUltimateCart.config"
                @config-changed="onSystemConfigChanged"
                @sales-channel-changed="onSalesChannelChanged"
            />

        </sw-card-view>
    </template>
    {% endblock %}

</sw-page>
{% endblock %}
